import React, { Component } from "react";
import axios from "axios";
import { toast } from "react-toastify";

export default class RecordingLikeScoresPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            linksInput: "",
            loading: false,
            result: null,
        };
    }

    handleInputChange = (e) => {
        this.setState({ linksInput: e.target.value });
    };

    parseLinks = (rawValue) => {
        if (!rawValue) return [];

        const lines = rawValue
            .split(/\r?\n|,|;/)
            .map((item) => item.trim())
            .filter((item) => item.length > 0);

        return Array.from(new Set(lines));
    };

    handleSubmit = () => {
        const links = this.parseLinks(this.state.linksInput);

        if (links.length === 0) {
            toast.warning("Vui long nhap it nhat 1 link");
            return;
        }

        this.setState({ loading: true, result: null });

        axios
            .post(
                `${global.config.apiDomain}/mc-recording/web/recording-like-scores`,
                { links },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )
            .then((res) => {
                const responseData = res?.data;
                if (responseData?.status !== "OK") {
                    toast.error(responseData?.message || "Khong the lay diem recording");
                    this.setState({ loading: false });
                    return;
                }

                this.setState({
                    loading: false,
                    result: responseData.data || null,
                });
            })
            .catch((error) => {
                const errorMessage =
                    error?.response?.data?.message ||
                    error?.message ||
                    "Khong the lay diem recording";
                toast.error(errorMessage);
                this.setState({ loading: false });
            });
    };

    renderResultTable() {
        const { result } = this.state;
        if (!result || !Array.isArray(result.items)) return null;

        return (
            <div className="table-responsive mt-3">
                <table className="table table-hover table-bordered">
                    <thead className="thead-light">
                        <tr>
                            <th>Link</th>
                            <th style={{ width: "120px" }}>Diem</th>
                            <th style={{ width: "120px" }}>So comment</th>
                            <th style={{ width: "120px" }}>So share</th>
                            <th style={{ width: "160px" }}>Recording ID</th>
                            <th>Loi</th>
                        </tr>
                    </thead>
                    <tbody>
                        {result.items.map((item, index) => (
                            <tr key={`${item.link || "link"}-${index}`}>
                                <td>
                                    {item.link ? (
                                        <a
                                            href={item.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {item.link}
                                        </a>
                                    ) : (
                                        "-"
                                    )}
                                </td>
                                <td>{item.score ?? "-"}</td>
                                <td>{item.commentCount ?? "-"}</td>
                                <td>{item.shareCount ?? "-"}</td>
                                <td>{item.recordingId ?? "-"}</td>
                                <td>{item.error || "-"}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }

    render() {
        const { linksInput, loading, result } = this.state;

        return (
            <div
                className="container-fluid"
                style={{ marginTop: "100px", marginBottom: "20px" }}
            >
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header bg-primary text-white">
                                <h3 className="card-title mb-0">
                                    <i className="fa-solid fa-heart mr-2"></i>
                                    Recording Like Scores
                                </h3>
                            </div>
                            <div className="card-body">
                                <div className="form-group">
                                    <label htmlFor="recording-links">
                                        <strong>Danh sach links</strong>
                                    </label>
                                    <textarea
                                        id="recording-links"
                                        className="form-control"
                                        rows="8"
                                        value={linksInput}
                                        onChange={this.handleInputChange}
                                        placeholder="Moi dong 1 link, hoac tach bang dau phay"
                                        disabled={loading}
                                    />
                                </div>

                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={this.handleSubmit}
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <>
                                            <span
                                                className="spinner-border spinner-border-sm mr-2"
                                                role="status"
                                                aria-hidden="true"
                                            ></span>
                                            Dang tinh diem...
                                        </>
                                    ) : (
                                        <>
                                            <i className="fa-solid fa-calculator mr-2"></i>
                                            Tinh diem
                                        </>
                                    )}
                                </button>

                                {result && (
                                    <div className="mt-3">
                                        <span className="mr-3">
                                            <strong>Total:</strong> {result.total ?? 0}
                                        </span>
                                        <span>
                                            <strong>Success:</strong> {result.success ?? 0}
                                        </span>
                                    </div>
                                )}

                                {this.renderResultTable()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
